import { hrefFor, navigate } from '../router'
import type { Route } from '../router'

/**
 * A real `<a href>` that navigates in place.
 *
 * Every place in the app is a URL now, so a link should be one: it can be
 * opened in a new tab, copied, and read by a screen reader as a link. A plain
 * click stays in the app; anything with a modifier is the browser's.
 */
export function Link({
  to,
  children,
  className,
  current,
  onNavigate,
}: {
  to: Route
  children: React.ReactNode
  className?: string
  current?: boolean
  onNavigate?: () => void
}): JSX.Element {
  return (
    <a
      href={hrefFor(to)}
      className={className}
      aria-current={current ? 'page' : undefined}
      onClick={(e) => {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
        e.preventDefault()
        navigate(to)
        onNavigate?.()
      }}
    >
      {children}
    </a>
  )
}
